import { useLocation } from 'react-router-dom'
import { FaInfoCircle } from 'react-icons/fa'
import { Card, PageHeader } from '../components/common'
import { useBreadcrumb } from '../hooks/useBreadcrumb'
import { findNavNode } from '../config/navigation'

/**
 * 「页面建设中」的通用占位页，被 App.jsx 里七个 /finance/* 路由复用。
 *
 * 标题与面包屑都从站点结构（config/navigation.js）取。这里原先各自维护着 titleMap
 * 与 breadcrumbMap 两张表，且都已过期：里面还留着 /my-consolidation、/my-orders
 * 这些早已有真实页面的路径，以及散货板块下线后不可达的 /cargo-search 等；而七个
 * /finance/* 的面包屑写的是「财务管理 / xxx」，缺了「我的」这一级。
 */
export default function PlaceholderPage() {
  const location = useLocation()
  const breadcrumb = useBreadcrumb()
  const title = findNavNode(location.pathname)?.label || '功能页面'

  return (
    <div>
      <PageHeader
        icon={FaInfoCircle}
        title={title}
        subtitle="页面建设中"
        breadcrumb={breadcrumb}
      />
      <div className="container py-8">
        <Card>
          <Card.Body>
            <div className="text-gray-600">页面开发中...</div>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
